/* eslint-disable */
import {
  ADD_TRACK_TO_USER_PLAN_FAIL,
  ADD_TRACK_TO_USER_PLAN_START,
  ADD_TRACK_TO_USER_PLAN_SUCCESS,
  CLEAR_COLLECTION_TRACKS,
  CLEAR_HAS_REWARDS,
  DELETE_TRACK_FROM_STUDY_PLAN_FAIL,
  DELETE_TRACK_FROM_STUDY_PLAN_START,
  DELETE_TRACK_FROM_STUDY_PLAN_SUCCESS,
  GET_COLLECTION_TRACKS_FAIL,
  GET_COLLECTION_TRACKS_START,
  GET_COLLECTION_TRACKS_SUCCESS,
  GET_TRACK_BY_ID_FAIL,
  GET_TRACK_BY_ID_START,
  GET_TRACK_BY_ID_SUCCESS,
  GET_TRACK_REPORT_FAIL,
  GET_TRACK_REPORT_START,
  GET_TRACK_REPORT_SUCCESS,
  GET_TRACK_SECTIONS_BY_ID_FAIL,
  GET_TRACK_SECTIONS_BY_ID_START,
  GET_TRACK_SECTIONS_BY_ID_SUCCESS,
  GET_TRACKS_FAIL,
  GET_TRACKS_START,
  GET_TRACKS_STATUS_FAIL,
  GET_TRACKS_STATUS_START,
  GET_TRACKS_STATUS_SUCCESS,
  GET_TRACKS_SUCCESS,
  RESCHEDULE_USER_TRACK_FAIL,
  RESCHEDULE_USER_TRACK_START,
  RESCHEDULE_USER_TRACK_SUCCESS,
} from './constants';

const DEFAULT_COLLECTION_TRACKS_PAGINATION = {
  currentPage: 0,
  pageSize: 20,
  totalElements: 0,
  totalPages: 0,
};

export const DEFAULT_COLLECTION_TRACKS_SORT = 'createdDate,desc';

const initialState = {
  isLoading: false,
  isError: false,
  tracks: [],
  track: {},
  currentPage: 0,
  pageSize: 20,
  totalElements: 0,
  totalPages: 0,
  statuses: [],
  partialFinishing: 0,
  trackSections: [],
  sectionConsecutive: false,
  isLoadingSections: false,
  trackStudentPlanStatus: false,
  trackStudentPlanName: '',
  addedByAdmin: false,
  tags: [],
  rescheduledTrack: {},
  isReschedulingTrack: false,
  isRescheduleTrackError: false,
  collectionTracks: [],
  collectionTracksPagination: DEFAULT_COLLECTION_TRACKS_PAGINATION,
  collectionTracksSort: DEFAULT_COLLECTION_TRACKS_SORT,
  isTrackReportLoading: false,
  isTrackReportError: false,
  trackRewards: [],
  sectionsRewards: [],
  hasRewards: false,
};

export default (state = initialState, { type, response, value, action, headers }) => {
  switch (type) {
    case GET_TRACK_SECTIONS_BY_ID_START:
      return {
        ...state,
        isLoadingSections: true,
      };

    case GET_TRACKS_STATUS_START:
    case GET_TRACK_BY_ID_START:
    case GET_TRACKS_START:
    case ADD_TRACK_TO_USER_PLAN_START:
    case DELETE_TRACK_FROM_STUDY_PLAN_START:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };

    case RESCHEDULE_USER_TRACK_START:
      return {
        ...state,
        isReschedulingTrack: true,
        isRescheduleTrackError: false,
      };

    case GET_TRACKS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        tracks: response?.content,
        currentPage: response.number,
        pageSize: response.size,
        totalElements: response.totalElements,
        totalPages: response.totalPages,
      };

    case GET_TRACK_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        track: response,
        trackStudentPlanStatus: response?.trackStudentPlanStatus,
        trackStudentPlanName: response?.trackStudentPlanName,
        addedByAdmin: response?.addedByAdmin,
        tags: response?.tags?.sort((a, b) => a?.name.localeCompare(b?.name)),
        trackRewards: response?.rewardsDto,
        hasRewards: response?.rewardsDto?.length > 0,
      };

    case GET_TRACKS_STATUS_SUCCESS:
      return {
        ...state,
        statuses: response,
      };

    case GET_TRACK_SECTIONS_BY_ID_SUCCESS:
      const filteredRewards = response?.sections
        .flatMap(section => section.rewardsDto || [])
        .filter((reward, index, self) => index === self.findIndex(r => r.id === reward.id));

      return {
        ...state,
        partialFinishing: response?.partialFinishing,
        trackSections: response?.sections.sort((a, b) => a?.position - b?.position),
        sectionsRewards: filteredRewards,
        sectionConsecutive: response?.sectionConsecutive,
        isLoadingSections: false,
      };

    case ADD_TRACK_TO_USER_PLAN_SUCCESS:
      return { ...state, isLoading: false, isError: false };

    case DELETE_TRACK_FROM_STUDY_PLAN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
      };

    case RESCHEDULE_USER_TRACK_SUCCESS:
      return {
        ...state,
        isReschedulingTrack: false,
        isRescheduleTrackError: false,
        rescheduledTrack: response,
      };

    case GET_TRACK_SECTIONS_BY_ID_FAIL:
      return {
        ...state,
        isLoadingSections: false,
      };

    case RESCHEDULE_USER_TRACK_FAIL:
      return {
        ...state,
        isReschedulingTrack: false,
        isRescheduleTrackError: true,
      };

    case GET_TRACKS_STATUS_FAIL:
    case GET_TRACK_BY_ID_FAIL:
    case GET_TRACKS_FAIL:
    case ADD_TRACK_TO_USER_PLAN_FAIL:
    case DELETE_TRACK_FROM_STUDY_PLAN_FAIL:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };

    case GET_COLLECTION_TRACKS_START:
      return {
        ...state,
        isLoading: true,
        isError: false,
        collectionTracksSort: action?.sort,
      };

    case GET_TRACK_REPORT_START:
      return { ...state, isTrackReportLoading: true, isTrackReportError: false };

    case GET_TRACK_REPORT_SUCCESS:
      return { ...state, isTrackReportLoading: false, isTrackReportError: false };

    case GET_TRACK_REPORT_FAIL:
      return { ...state, isTrackReportLoading: false, isTrackReportError: true };

    case GET_COLLECTION_TRACKS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        collectionTracks: response?.content,
        collectionTracksPagination: {
          currentPage: response?.number,
          pageSize: response?.size,
          totalElements: response?.totalElements,
          totalPages: response?.totalPages,
        },
        collectionTracksSort: action?.sort,
      };

    case GET_COLLECTION_TRACKS_FAIL:
      return {
        ...state,
        isLoading: false,
        isError: true,
        collectionTracksSort: action?.sort,
      };

    case CLEAR_COLLECTION_TRACKS:
      return {
        ...state,
        collectionTracks: [],
        collectionTracksPagination: { ...DEFAULT_COLLECTION_TRACKS_PAGINATION },
        collectionTracksSort: DEFAULT_COLLECTION_TRACKS_SORT,
      };

    case CLEAR_HAS_REWARDS:
      return {
        ...state,
        trackRewards: [],
        sectionsRewards: [],
        hasRewards: false,
      };

    default:
      return { ...state };
  }
};
